import React from "react";

export default function MessageList(props) {
  const messages = props.messages || [];
  if (!Array.isArray(messages)) return null;

  const AssistantAvatar = () => {
    return (
      <div className="symbol symbol-circle symbol-40">
        <span className="symbol-label font-size-h5 bg-light-primary text-primary">
          AI
        </span>
      </div>
    );
  };

  const UserAvatar = () => {
    return (
      <div className="symbol symbol-circle symbol-40">
        <span className="symbol-label font-size-h5">Я</span>
      </div>
    );
  };

  const MessageDate = (props) => {
    return (
      <span className="text-muted font-size-sm">
        {props.message.date.toLocaleString()}
      </span>
    );
  };

  const SourceChips = (props) => {
    const sources = props.sources || [];
    if (!sources.length) return null;
    return (
      <div className="mt-2">
        {sources.map((source, index) => (
          <a
            key={index}
            href={source.url || "#"}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-sm btn-light-primary font-weight-bold mr-2 mb-1 px-3 py-1"
            style={{ borderRadius: 16, fontSize: "0.8rem" }}
          >
            {source.label || source.url || "Источник"}
          </a>
        ))}
      </div>
    );
  };

  return (
    <>
      <div className="messages-continer">
        {messages.map((message, index) => {
          const alignRight = message.right ? true : false;
          const isThinking = message.thinking ? true : false;

          return (
            <div
              key={message.id || index}
              className={`d-flex flex-column mb-5 align-items-${
                alignRight ? "end" : "start"
              }`}
            >
              <div className="d-flex align-items-center">
                {!alignRight && <AssistantAvatar />}
                <div>
                  {alignRight && <MessageDate message={message} />}
                  <span className="text-dark-75 mx-3 font-weight-bold font-size-h6">
                    {message.author}
                  </span>
                  {!alignRight && <MessageDate message={message} />}
                </div>
                {alignRight && <UserAvatar />}
              </div>
              <div
                style={{ whiteSpace: "pre-line" }}
                className={`mt-2 rounded p-5 ${
                  alignRight ? "bg-light-primary" : "bg-light-success"
                } text-dark-50 font-weight-bold font-size-lg text-left max-w-400px${
                  isThinking ? " font-italic" : ""
                }`}
              >
                {message.text}
              </div>
              {!alignRight && message.sources && (
                <SourceChips sources={message.sources} />
              )}
            </div>
          );
        })}
      </div>
    </>
  );
}
